import { Box } from "@mui/material";
import { motion, useReducedMotion } from "framer-motion";
import type { FC } from "react";
import { HALLOWEEN } from "@/theme/tokens";
import { BAT_PATH, BAT_VIEW_HEIGHT, BAT_VIEW_WIDTH } from "./halloweenShapes";

const HOVER_PX = 6;
const HOVER_SECONDS = 1.4;
const FLAP_SECONDS = 0.3;
const FLAP_CLOSED = 0.35;
const SHADOW_NARROW = 0.7;
const BAT_ASPECT = BAT_VIEW_WIDTH / BAT_VIEW_HEIGHT;
const SHADOW_HEIGHT_PX = 4;
/** The shadow spans this share of the bat's wingspan. */
const SHADOW_WIDTH_SHARE = 0.6;

/** A bat flapping in place over its own shadow. */
export const FlappingBatLoader: FC<{ dataTestId?: string }> = ({ dataTestId }) => {
	const reduceMotion = useReducedMotion();
	const loop = { repeat: Number.POSITIVE_INFINITY, ease: "easeInOut" } as const;
	return (
		<Box data-testid={dataTestId} aria-hidden sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
			<motion.div animate={reduceMotion ? undefined : { y: [0, -HOVER_PX, 0] }} transition={{ ...loop, duration: HOVER_SECONDS }}>
				<motion.svg
					width={HALLOWEEN.SIZE.BAT_WIDTH}
					height={HALLOWEEN.SIZE.BAT_WIDTH / BAT_ASPECT}
					viewBox={`0 0 ${BAT_VIEW_WIDTH} ${BAT_VIEW_HEIGHT}`}
					animate={reduceMotion ? undefined : { scaleY: [1, FLAP_CLOSED, 1] }}
					transition={{ ...loop, duration: FLAP_SECONDS }}
				>
					<path d={BAT_PATH} fill={HALLOWEEN.BAT} />
				</motion.svg>
			</motion.div>
			<motion.div
				style={{ width: HALLOWEEN.SIZE.BAT_WIDTH * SHADOW_WIDTH_SHARE, height: SHADOW_HEIGHT_PX, borderRadius: "50%", background: HALLOWEEN.SHADOW }}
				animate={reduceMotion ? undefined : { scaleX: [1, SHADOW_NARROW, 1] }}
				transition={{ ...loop, duration: HOVER_SECONDS }}
			/>
		</Box>
	);
};
